<nb-card [class.large]="large">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <span [innerHTML]="title"></span>
    <button *ngIf="showCloseWithNoAction" nbButton status="danger" (click)="abort()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body [innerHTML]="description"></nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="confirm()" class="float-right" *ngIf="!withConsent || consent">{{ isWarning ? 'Ok' : (yesText !== '' ? yesText : 'Da') }}</button>
    <button nbButton *ngIf="!isWarning" status="danger" (click)="dismiss()">{{ (noText !== '' ? noText : 'Nu') }}</button>
    <nb-checkbox *ngIf="withConsent && !consent" (click)="consent = true" class="float-right">Sunt sigur de această acțiune!</nb-checkbox>
  </nb-card-footer>
</nb-card>
